export default class BaseUIComponent {
  constructor () {
    this.parent = document.getElementById('canvas-container'); //TODO
  }
}



// WEBPACK FOOTER //
// ./src/ui/baseUIComponent.js